import { create } from "zustand";
import type { AlignmentGuide } from "../../../lib/canvas-alignment";

// スマートガイド（整列補助線）の一時表示状態を持つ Zustand store。
// ドラッグ移動・複製中のみ guides を積み、overlay が購読して描画する。
// 高頻度更新（pointermove ごと）になるため、この store を購読するのは overlay のみとし、
// 内容が変わらないフレームでは setGuides を no-op にして無駄な再描画を避ける。

interface AlignmentGuideState {
  readonly guides: readonly AlignmentGuide[];
  readonly setGuides: (guides: readonly AlignmentGuide[]) => void;
  readonly clearGuides: () => void;
}

// 2 つのガイド配列が実質的に等しいか（位置・範囲まで一致するか）を判定する。
// 連続フレームで同じガイドが出続けるケースの再描画を抑止する。
function guidesEqual(a: readonly AlignmentGuide[], b: readonly AlignmentGuide[]): boolean {
  if (a === b) return true;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    const ga = a[i];
    const gb = b[i];
    if (
      !ga ||
      !gb ||
      ga.axis !== gb.axis ||
      ga.position !== gb.position ||
      ga.start !== gb.start ||
      ga.end !== gb.end
    ) {
      return false;
    }
  }
  return true;
}

export const useAlignmentGuideStore = create<AlignmentGuideState>((set, get) => ({
  guides: [],
  setGuides: (guides) => {
    if (guidesEqual(get().guides, guides)) return;
    set({ guides });
  },
  clearGuides: () => {
    if (get().guides.length === 0) return;
    set({ guides: [] });
  },
}));
